export default __webpack_public_path__ + "static/media/tooltipIcon.d4f545d8.svg";